import { AxiosResponse } from 'axios';

// stores
import { IAnalyticsStore } from 'stores/AnalyticsStore';

// types
import { IResult } from 'services/Result';

export class AxiosResponseHelper {
  public static IsSuccessfulResponse = (response: AxiosResponse) => {
    return response && [200, 204].some((value) => response.status === value);
  };

  public static ReportErrors = (analyticsStore: IAnalyticsStore, messagePrefix: string, responseData: IResult<any>) => {
    analyticsStore.sendExceptionEvent(`${messagePrefix}: ${JSON.stringify(responseData, null, '  ')}`);

    let msg = messagePrefix;
    if (responseData && responseData.errorMessage) {
      msg = `${msg} - ${responseData.errorMessage}`;
    }
    
  };
}
